<nav class="side-header">

    <div class="side-header-top">

        <button
            class="side-header-btn"
            (click)="menuClick.emit()">

            <span class="material-icons">
                menu
            </span>

        </button>

    </div>

    <div class="side-header-center">

        <img
            src="assets/icons/logo_deBrain.png"
            alt="Logo"
            class="side-header-logo">

    </div>

    <div class="side-header-bottom">

        <button
            class="side-header-action"
            (click)="onClickViewerEmitter.emit()">

            <span class="material-icons">
                visibility
            </span>

            <span>Visor</span>

        </button>

    </div>

</nav>